import React from 'react';
import PropTypes from 'prop-types';
import {
  HorizontalContent,
} from '../../../styles';
import TemplateHeaderContent from './content';

const TemplateHeader = ({
  onCreateTemplate,
  description,
  title,
  buttonText,
}) => (
  <>
    <HorizontalContent>
      <TemplateHeaderContent
        title={title}
        description={description}
        buttonText={buttonText}
        handleCreateTemplate={onCreateTemplate}
      />
    </HorizontalContent>
  </>
);

TemplateHeader.propTypes = {
  onCreateTemplate: PropTypes.func.isRequired,
  description: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
};

export default TemplateHeader;
